import React, {useState, useEffect} from "react";
import { Link, useNavigate } from "react-router-dom";
import { createBrowserHistory } from 'history';
import logo from '../img/logo.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Form, Container } from 'react-bootstrap';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import RegistrationModal from '../components/RegistrationModal';

let history = createBrowserHistory();

export default function Login(props) { 
  const navigate = useNavigate();
  let Params = new URLSearchParams(history.location.search) // URLクエリを使用する
  let ModalShow = false
  let ModalRegistProcessShow = false
  let ModalLoginProcessShow = false

  if (Params.get("view") === "Regist") { //URLが「/Login?view=Regist」の場合は会員登録画面表示を行う。
    ModalShow = true  //会員登録画面をモーダルで表示する
  } else {
    ModalShow = false //会員登録画面は非表示とする。（ログイン画面を表示）
  }
  if (Params.get("view") === "Regist_Process") { //URLが「/Login?view=Regist_Process」の場合は会員登録処理中表示を行う。
    ModalRegistProcessShow = true  //会員登録処理中画面をモーダルで表示する
  } else {
    ModalRegistProcessShow = false //会員登録処理中画面を非表示にする
  }
  if (Params.get("view") === "Login_Process") { //URLが「/Login?view=Login_Process」の場合はログイン処理中表示を行う。
    ModalLoginProcessShow = true  //ログイン処理中画面をモーダルで表示する
  } else {
    ModalLoginProcessShow = false //ログイン処理中画面を非表示にする
  }

  const [ modalShow,                     setModalShow                     ] = useState(ModalShow)              //ユーザー新規登録画面の表示コントロール（true=会員登録画面、false=ログイン画面）
  const [ modalRegistProcessShow,        setModalRegistProcessShow        ] = useState(ModalRegistProcessShow) //ユーザー新規登録処理中画面の表示コントロール（true=処理中画面、false=ログイン画面）
  const [ modalLoginProcessShow,         setModalLoginProcessShow         ] = useState(ModalLoginProcessShow)  //ログイン処理中画面の表示コントロール（true=ログイン中画面、false=ログイン画面）
  const [ isLogin,                       setIsLogin                       ] = useState(false)                  //ログイン状態
  const [ loginEmailValue,               setLoginEmailValue               ] = useState('')                     //ユーザーのメールアドレス
  const [ loginPasswordValue,            setLoginPasswordValue            ] = useState('')                     //ユーザーのパスワード
  const [ loginEmailAlertText,           setLoginEmailAlertText           ] = useState()                       //ログインメールアドレス警告文字列

  //画面表示時、画面更新時に作用する。
  useEffect(() => {
    if (modalShow === true) {
      document.title = '会員登録 - ふぁみかるくん'
    } else if (modalRegistProcessShow === true) {
      document.title = '会員登録処理中 - ふぁみかるくん'
    } else if (modalLoginProcessShow === true) {
      document.title = 'ログイン処理中 - ふぁみかるくん'
    } else {
      document.title = 'ログイン - ふぁみかるくん'
    }
  }, [modalShow, modalRegistProcessShow, modalLoginProcessShow])

  useEffect(() => {
    // componentDidMount のタイミングで実行したい処理を記述
    return () => {
      // componentWillUnmount のタイミングで実行したい処理を記述
      document.title = 'ふぁみかるくん' //家族ホーム画面を離れる際、ページタイトルを初期値に戻す
    }
  }, []);

  //ログイン画面表示時は、エラー防止のため、１回だけ画面の再読み込みを行う。
  if (sessionStorage.getItem("LoginReload") === null) {
    sessionStorage.setItem('LoginReload', 'true'); //セッションストレージにLoginReload=trueを保存して、ログイン画面が繰り返し再読み込みされないようにする
    window.location.reload() //ブラウザの機能でページ再読み込みを行う
  }

  //「ログイン」ボタンを押した際の処理
  const handleEmailLogin = () => {
    let emailVerified = false
    let user = []
    Promise.resolve()
    .then(() => {
      return new Promise((resolve) => {
        //ログイン処理中画面に移動
        setModalShow(false)              //会員登録画面のモーダルを非表示にする
        setModalRegistProcessShow(false) //会員登録処理中画面のモーダルを非表示する
        setModalLoginProcessShow(true)   //ログイン中画面のモーダルを表示にする
        navigate('/Login?view=Login_Process')
        resolve()
      })
    })
    .then(() => {
      return new Promise((resolve) => {
        firebase.auth().signOut().then(() => {//ユーザーのサインアウトを行う。
          resolve()
        })
      })
    })
    .then(() => {
      return new Promise((resolve) => {
        setIsLogin(false)
        resolve()
      })
    })
    .then(() => {
      return new Promise((resolve) => {
        //メールアドレスとパスワードを使用してユーザーのログインを行う。
        firebase.auth().signInWithEmailAndPassword(loginEmailValue, loginPasswordValue)
        .then((result) => {
          user = result.user;
          if(isLogin) //isLoginを読み取るだけ
          console.log("user.email: " + user.email)
          console.log("user.uid: " + user.uid)
          emailVerified = user.emailVerified //Eメールアドレスの認証可否状況
          resolve()
        })
        .catch((error) => { //ログイン失敗を検知
          if (error.code === 'auth/user-not-found' && error.message === 'There is no user record corresponding to this identifier. The user may have been deleted.') {
            console.log(`ログインに失敗しました。\n code: ${error.code}\n message: ${error.message}`)
            alert('ログインに失敗しました。\nアカウントは存在しません。')
          } else if (error.code === 'auth/invalid-email' && error.message === 'The email address is badly formatted.') {
            console.log(`ログインに失敗しました。\n code: ${error.code}\n message: ${error.message}`)
            alert('ログインに失敗しました。\n正しいメールアドレスを入力してください。')
          } else if (error.code === 'auth/wrong-password' && error.message === 'The password is invalid or the user does not have a password.') {
            console.log(`ログインに失敗しました。\n code: ${error.code}\n message: ${error.message}`)
            alert('ログインに失敗しました。\nパスワードを確認してください')
          } else if (error.code === 'auth/user-disabled' && error.message === 'The user account has been disabled by an administrator.') {
            console.log(`ログインに失敗しました。\n code: ${error.code}\n message: ${error.message}`)
            alert('ログインに失敗しました。\nサービスは無効化されています。')
          } else {
            console.log(`ログインに失敗しました。\n code: ${error.code}\n message: ${error.message}`)
            alert('ログインに失敗しました。')
          }

          //ログイン画面に移動
          setModalShow(false)              //会員登録画面のモーダルを非表示にする
          setModalRegistProcessShow(false) //会員登録処理中画面のモーダルを非表示する
          setModalLoginProcessShow(false)  //ログイン中画面のモーダルを非表示にする
        })
      })
    })
    .then(() => {
      if (emailVerified) { //Eメールアドレスの認証可否をチェックする。
        let FamilyID = ''
        console.log("Email verified. user.emailVerified: " + user.emailVerified)  //メールアドレス承認済みの場合

        //「Person」コレクションからユーザーの姓・名を取得し、コンソールに出力する。
        firebase.firestore().collection("Person").doc(user.uid).get().then((result) => {
          var data = result.data()
          console.log("familyName: " + data.FamilyName)
          console.log("firstName: " + data.FirstName)
          FamilyID = data.FamilyID[0].id //1件目の家族IDを取得する。
          setIsLogin(true)
          navigate('/FamilyHome/' + FamilyID)
        })
      } else {
        console.log("Do verify email. user.emailVerified: " + user.emailVerified) //メールアドレス未承認の場合
        var actionCodeSettings = {
          url: 'https://app.famikar.jp/', //メールアドレス認証後に開くURLを指定する
          handleCodeInApp: false,         //Webサイトとして開く設定
        }
        firebase.auth().currentUser.sendEmailVerification(actionCodeSettings) //メールアドレス未承認の場合は、確認メールを送信する。
        .then(() => { //確認メール送信成功時
          console.log('メールアドレス確認用のメールをお送りしました。 送信先アドレス：' + user.email)
          alert('メールアドレス確認用のメールをお送りしました。\n送信先アドレス：' + user.email)
          //ログイン画面に移動
          setModalShow(false)              //会員登録画面のモーダルを非表示にする
          setModalRegistProcessShow(false) //会員登録処理中画面のモーダルを非表示する
          setModalLoginProcessShow(false)  //ログイン中画面のモーダルを非表示にする
        })
        .catch((error) => { //確認メール送信失敗時
          if (error.code === 'auth/too-many-requests' && error.message === 'We have blocked all requests from this device due to unusual activity. Try again later.') {
            console.log('メールアドレス確認メールの送信に失敗しました。\n登録メールアドレス(' + user.email + ')\n' + error.code + '\n' + error.message)
            alert('メールアドレス確認メールの送信に失敗しました。\n登録メールアドレス(' + user.email + ')\n送信済みの確認メールを確認してください。')
          } else {
            console.log('メールアドレス確認メールの送信に失敗しました。\n登録メールアドレス(' + user.email + ')\n' + error.code + '\n' + error.message)
            alert('メールアドレス確認メールの送信に失敗しました。\n登録メールアドレス(' + user.email + ')\n' + error.message)
          }
          //ログイン画面に移動
          setModalShow(false)              //会員登録画面のモーダルを非表示にする
          setModalRegistProcessShow(false) //会員登録処理中画面のモーダルを非表示する
          setModalLoginProcessShow(false)  //ログイン中画面のモーダルを非表示にする
          navigate('/Login')
        })
      }
    })
  }

  //ログイン・新規作成用メールアドレス
  const handleLoginEmailChange = (e) => {
    setLoginEmailValue(e.target.value)
  }

  //新規作成用メールアドレス入力から離れた際にチェックする
  const handleLoginEmailBlue = (e) => {
    const regex = /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/; //メールアドレスの正規表現文字列
    if (!regex.test(e.target.value)) { //メールアドレスの形式をチェックする。
      setLoginEmailAlertText("メールアドレスの形式が間違っています。")
    } else {
      setLoginEmailAlertText('') //メールアドレスの形式が正しい場合はメッセージを出さない。
    }
  }

  //ログイン・新規作成用パスワード
  const handleLoginPasswordChange = (e) => {
    setLoginPasswordValue(e.target.value)
  }
  
  //パスワードを忘れた場合の処理（パスワード再設定）
  const handleSendPasswordResetEmail = () => {
    console.log("handleSendPasswordResetEmail")
    Promise.resolve()
    .then(() => {
      var actionCodeSettings = {
        url: 'https://app.famikar.jp/', //メールアドレス認証後に開くURLを指定する
        handleCodeInApp: false,         //Webサイトとして開く設定
      }
      return new Promise((resolve, reject) => {
        firebase.auth().sendPasswordResetEmail(loginEmailValue, actionCodeSettings)
        .then(() => {
          alert('パスワードリセットメールを送信しました。\n送信先アドレス：' + loginEmailValue)
          resolve()
        })
        .catch((error) => {
          if (error.code === "auth/invalid-email" && error.message === "The email address is badly formatted.") {
            console.log('code:\n' + error.code + '\nmessage:\n' + error.message)
            alert('パスワードリセットメールを送信に失敗しました。\n送信先メールアドレスの形式が正しくありません。\n送信先アドレス：' + loginEmailValue)
          } else if (error.code === "auth/user-not-found" && error.message === "There is no user record corresponding to this identifier. The user may have been deleted.") {
            console.log('code:\n' + error.code + '\nmessage:\n' + error.message)
            alert('パスワードリセットメールを送信に失敗しました。\n対象のアカウントが存在しません。\n送信先アドレス：' + loginEmailValue)
          } else {
            console.log('code:\n' + error.code + '\nmessage:\n' + error.message)
            alert('パスワードリセットメールを送信に失敗しました。\n送信先アドレス：' + loginEmailValue)
          }

          reject()
        })
      })
    })
    .then(() => {
      //パスワードリセットメール送信時の処理
      console.log("パスワードリセットメールを送信しました。")
    })
    .catch(() => {
      //パスワードリセットメール送信失敗時の処理
      console.log("パスワードリセットメールを送信に失敗しました。")
    })
  }

  // 登録完了時のハンドラ
  const handleRegistrationComplete = () => {
    // 登録完了後、ログイン画面に遷移
    setModalShow(false);
    setModalRegistProcessShow(false);
    setModalLoginProcessShow(false);
    setIsLogin(false);
    navigate('/Login');
  };

  return (
    <div>
      <ul style={{ display: 'flex', justifyContent: 'center', padding: '0px' }}>
        <div className="justify-md-center align-Center">
          <Link to='/'><img src={logo} alt="ふぁみかるくんロゴ" /></Link>

          {/* ログイン用メールアドレス、パスワード入力画面 */}
          <div>
            <Form onSubmit={(e) => handleEmailLogin(e)}>
              <Form.Group controlId="formLoginEmail">
                <Form.Label>Eメールアドレス</Form.Label>
                <Form.Control type="email" placeholder="Eメールアドレスを入力ください" name="formLoginEmail"
                  value={loginEmailValue} onChange={(e) => handleLoginEmailChange(e)} />
                <Form.Text className="text-muted">　　　　　　　　　　　　　　　　　　　　　　　</Form.Text>
              </Form.Group>

              <Form.Group controlId="formLoginPassword">
                <Form.Label>パスワード</Form.Label>
                <Form.Control type="password" placeholder="パスワードを入力ください" name="formLoginPassword"
                  value={loginPasswordValue} onChange={(e) => handleLoginPasswordChange(e)} />
              </Form.Group>
            </Form>
          </div>

          {/* パスワードを忘れた場合はこちら */}
          <div>
            <Button
              variant="link"
              onClick={() => handleSendPasswordResetEmail()}
            >
              パスワードを忘れた場合はこちら
            </Button>
          </div>

          {/* 「ログイン」ボタン */}
          <button type="button" className="nav-link btn btn-primary w-100 m-5px text-center col-md" onClick={() => handleEmailLogin()} >
            ログイン
          </button>

          {/* 「会員登録」ボタン */}
          <button type="button" className="nav-link btn btn-primary w-100 m-5px text-center col-md"
            onClick={() => {
              document.title = '会員登録 - ふぁみかるくん'
              setModalShow(true)
              navigate('/Login?view=Regist')
            }}>
            会員登録
          </button>
          <Form.Text className="text-muted">
            <br />
            <a href="https://famikar.jp/privacy/" target="_blank" rel="noopener noreferrer">個人情報保護方針</a><br />
            <br />
            <a href="https://famikar.jp" target="_blank" rel="noopener noreferrer">ふぁみかるくん　サービスページ</a><br />
            <br />
            運営元：<a href="https://gometo.co.jp/" target="_blank" rel="noopener noreferrer">株式会社GoMeTo</a>
          </Form.Text>
          <div style={{color: '#888'}}>ふぁみかるくん Ver.2.0.2</div>

          {/* 会員登録モーダル */}
          <RegistrationModal
            show={modalShow}
            onHide={() => {
              setModalShow(false);
              navigate('/Login');
            }}
            email={loginEmailValue}
            isInvitation={false}
            onRegistrationComplete={handleRegistrationComplete}
          />

          {/* 処理中画面（modal） */}
          <Modal show={modalRegistProcessShow}>
            <Modal.Header>
              <Modal.Title>会員登録 - 処理中</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container>
                <div style={{margin: '7em 0'}}>
                  会員登録処理中<br />
                  画面を閉じないでください。
                </div>
              </Container>
            </Modal.Body>
            <Modal.Footer>
              
            </Modal.Footer>
          </Modal>

          {/* ログイン中画面（modal） */}
          <Modal show={modalLoginProcessShow}>
            <Modal.Header>
              <Modal.Title>ログイン - 処理中</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Container>
                <div style={{margin: '7em 0'}}>
                  ログイン処理中<br />
                  画面を閉じないでください。
                </div>
              </Container>
            </Modal.Body>
            <Modal.Footer>
              
            </Modal.Footer>
          </Modal>
        </div>
      </ul>
    </div>
  )
}
